import { Component, inject, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { MatchService } from '../../services/match.service';
import { ConversationService } from 'src/app/features/conversation/services/conversation.service';
import { UserStoreService } from 'src/app/features/user/store/user-store.service';
import { Router } from '@angular/router';
import { MatchUser } from '../../models/match-user';
import { VersionedImageUrlPipe } from 'src/app/common/pipes/versioned-image-url.pipe';

@Component({
  selector: 'app-list-match',
  standalone: true,
  imports: [VersionedImageUrlPipe],
  templateUrl: './list-match.component.html',
  styleUrl: './list-match.component.scss',
})
export class ListMatchComponent implements OnInit, OnChanges {
  matches: MatchUser[] = [];
  allMatches: MatchUser[] = [];
  userIdsWithConversations: number[] = [];
  @Input() excludeUserIds: number[] = [];

  private _matchService = inject(MatchService);
  private _conversationService = inject(ConversationService);
  private _userStore = inject(UserStoreService);
  private _router = inject(Router);

  myId = 0;

  ngOnInit(): void {
    this.myId = this._userStore.getUserId();
    this._matchService.getMatches().subscribe(users => {
      this._conversationService.getUserConversations().subscribe(conversations => {
        // Exclure les utilisateurs qui ont déjà une conversation (active ou expirée)
        this.userIdsWithConversations = conversations.payload
          .filter(conv => conv.lastMessage !== null)
          .flatMap(conv => conv.participants)
          .filter(p => p.id !== this.myId)
          .map(p => p.id);

        this.allMatches = users;
        this.filterMatches();
      });
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['excludeUserIds']) {
      this.filterMatches();
    }
  }

  filterMatches(): void {
    // Les matchs expirés restent visibles pendant leur fenêtre de coup de cœur.
    const allExcluded = [...new Set([...this.userIdsWithConversations, ...this.excludeUserIds])];
    this.matches = this._sortMatches(this.allMatches.filter(u => !allExcluded.includes(u.id)));
  }

  private _sortMatches(matches: MatchUser[]): MatchUser[] {
    return [...matches].sort((a, b) => {
      const aExpired = a.sessionExpired && !a.heartConfirmed;
      const bExpired = b.sessionExpired && !b.heartConfirmed;
      if (aExpired !== bExpired) {
        return aExpired ? 1 : -1;
      }
      const timeA = a.matchedAt ? new Date(a.matchedAt).getTime() : 0;
      const timeB = b.matchedAt ? new Date(b.matchedAt).getTime() : 0;
      return timeB - timeA;
    });
  }

  openConversationWith(user: MatchUser): void {
    if (!user?.id) {
      return;
    }

    // Vérifier si une conversation existe déjà
    this._conversationService.getUserConversations().subscribe(conversations => {
      const conv = conversations.payload.find(c =>
        c.participants.some((p: any) => p.id === user.id)
      );
      if (conv) {
        // Conversation existe → naviguer vers elle
        this._router.navigate(['/messages', conv.id]);
      } else {
        // Pas de conversation → ouvrir en mode "match"
        // Si session expirée, passer le paramètre pour afficher le mode expiré
        this._router.navigate(['/messages/match', user.id], {
          queryParams: user.sessionExpired
            ? { expired: 'true', expiredAt: user.sessionEndedAt }
            : {},
        });
      }
    });
  }
}
